<template>
    <div class="relative">
        <label class="sr-only">{{ srLabel }}</label>
        <button
            class="max-sm:w-full shadow dark:shadow-slate-900/50 font-medium text-sm rounded items-center gap-2 flex h-9 pl-4 pr-3 py-2 text-slate-800 justify-center sm:justify-start border border-slate-300 bg-white dark:bg-slate-800 whitespace-nowrap relative hover:bg-slate-200 active:border-slate-200 focus:outline-none focus:ring-inset focus:ring-slate-200 focus:ring-2 focus:border-slate-200 disabled:opacity-50 disabled:bg-white disabled:text-slate-800"
            as="button"
            @click="$emit('clicked')"
            tabindex="0"
            :disabled="disabled"
        >
            <span class="leading-tight">{{ buttonText }}</span>
            <div
                v-if="selectedCounter && selected.length"
                class="text-white text-xs font-bold bg-black p-1 rounded-full w-5 h-5 min-w-5 text-center inline-flex flex-col leading-none items-center justify-center"
            >
                {{ selected.length }}
            </div>
            <span>
                <i class="fa-solid fa-chevron-down fa-xs"></i>
            </span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        buttonText: String,
        srLabel: String,
        selected: Array,
        selectedCounter: Boolean,
        disabled: { type: Boolean, default: false },
    },
    setup(props) {
        return {};
    },
};
</script>
